import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import {
  ArrowRight,
  BatteryCharging,
  CheckCircle2,
  Factory,
  Gauge,
  Leaf,
  MapPin,
  PackageCheck,
  Route,
  ShieldCheck,
  Sparkles,
  Truck,
  Zap,
} from "lucide-react";
import heroImage from "../assets/voice-ev91-bannerr.png";
import secondBanner from "../assets/second-banne.jpg";
import missionImage from "../assets/mission.png";
import mapImage from "../assets/3pl.png";
import mobileApp from "../assets/mobile-screen1.png";
import evRental from "../assets/flipkart-ev91.png";
import threePl from "../assets/3-PL.jpg";
import evDelivery from "../assets/bigbasket-ev91.png";
import clientLogo1 from "../assets/client-logo1.png";
import clientLogo2 from "../assets/client-logo2.png";
import clientLogo3 from "../assets/client-logo3.png";
import clientLogo5 from "../assets/client-logo5.png";
import clientLogo6 from "../assets/client-logo6.png";
import clientLogo8 from "../assets/client-logo8.png";
import flipkartLogo from "../assets/Flipkart-logo.png";
import amazonLogo from "../assets/Amazon-Logo.png";
import safetyTech from "../assets/tech-safety.gif";
import partnerLogo1 from "../assets/partner-logo7.png";
import partnerLogo2 from "../assets/partner-logo2.png";
import partnerLogo3 from "../assets/partner-logo1.png";
import partnerLogo4 from "../assets/partner-logo4.png";
import partnerLogo5 from "../assets/partner-logo5.png";
import partnerLogo6 from "../assets/partner-logo6.png";
import partnerLogo7 from "../assets/partner-logo3.png";
import partnerLogo8 from "../assets/partner-logo8.jpg";
import bengaluru from "../assets/namm bengaluru.jpg";
import chennai from "../assets/chennai.png";
import delhi from "../assets/india_gate_delhi.jpg";
import hyd from "../assets/chaminar_hyd.jpg";
import mumbai from "../assets/mumbai-iconic.jpg";
import ScrollToTopButton from "../components/ScrollToTopButton";

const stats = [
  { value: "16M+", label: "orders delivered" },
  { value: "16,000+", label: "riders enabled" },
  { value: "7", label: "active cities" },
  { value: "1600+", label: "EVs in motion" },
];

const services = [
  {
    title: "EV-Based Delivery",
    text: "Fast, tracked, low-emission pickup and drop for food, grocery, pharma, and commerce partners.",
    image: evDelivery,
    icon: Truck,
  },
  {
    title: "3PL Logistics",
    text: "Managed last-mile operations, rider supply, fleet uptime, and hub-to-door execution at city scale.",
    image: threePl,
    icon: PackageCheck,
  },
  {
    title: "EV Rental",
    text: "Affordable electric two-wheelers for riders and businesses with support, service, and onboarding.",
    image: evRental,
    icon: BatteryCharging,
  },
];

const operatingSystem = [
  "Rider onboarding and city launch playbooks",
  "Live fleet visibility and route intelligence",
  "Maintenance support for reliable EV uptime",
  "Enterprise reporting across orders, riders, and impact",
];

const cities = [
  { name: "Bengaluru", image: bengaluru, detail: "Technology hub and core operations base" },
  { name: "Chennai", image: chennai, detail: "Southern logistics gateway" },
  { name: "Hyderabad", image: hyd, detail: "Rapid growth market" },
  { name: "Delhi-NCR", image: delhi, detail: "North India expansion hub" },
  { name: "Mumbai", image: mumbai, detail: "Dense commerce and delivery network" },
];

const logos = [
  clientLogo1,
  clientLogo2,
  clientLogo3,
  clientLogo5,
  clientLogo6,
  clientLogo8,
  flipkartLogo,
  amazonLogo,
];

const commercialPartners = [
  partnerLogo1,
  partnerLogo2,
  partnerLogo3,
  partnerLogo4,
  partnerLogo5,
  partnerLogo6,
  partnerLogo7,
  partnerLogo8,
];

const dailyOrders = [
  { month: "Sep", value: 14 },
  { month: "Oct", value: 17 },
  { month: "Nov", value: 14.5 },
  { month: "Dec", value: 14.5 },
  { month: "Jan", value: 14.1 },
  { month: "Feb", value: 14.5 },
  { month: "March", value: 18},
  { month: "April", value: 18.5},
];

const Home = () => {
  return (
    <>
      <Helmet>
        <title>EV91Technologies | Electric Mobility, Logistics & EV Rental</title>
        <meta
          name="description"
          content="EV91Technologies (VOICE) powers electric last-mile delivery, 3PL logistics, EV rentals, and sustainable city mobility across India."
        />
        <meta
          name="keywords"
          content="EV91, VOICE, electric vehicle logistics, EV delivery, 3PL, EV rental, green logistics India"
        />
        <link rel="canonical" href="https://ev91riderz.com/" />
      </Helmet>

      <section className="relative -mt-6 min-h-[86vh] overflow-hidden bg-[#07120f] text-white">
        {/* Desktop Hero Image */}
        <img
          src={heroImage}
          alt="EV91 electric delivery fleet"
          className="absolute inset-0 h-100 w-100 object-cover opacity-60 hidden sm:block"
        />
        {/* Mobile Hero Image */}
        <img
          src={mobileApp}
          alt="EV91 mobile app"
          className="absolute inset-0 h-full w-full object-cover opacity-70 block sm:hidden"
        />
{/* <div className="absolute inset-0 bg-[linear-gradient(90deg,rgba(5,18,15,0.65)_0%,rgba(5,18,15,0.45)_42%,rgba(5,18,15,0.15)_100%)]" />        <div className="absolute inset-x-0 bottom-0 h-40 bg-gradient-to-t from-[#f6faf7] to-transparent" /> */}
        <div className="relative z-10 mx-auto flex min-h-[86vh] max-w-7xl flex-col justify-center px-5 py-24 lg:px-8">
          <div className="max-w-3xl">
            <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/10 px-4 py-2 text-sm font-bold text-white backdrop-blur-md shadow-lg">
  <Sparkles className="h-4 w-4 text-lime-300" />
  Electric logistics built for modern Indian cities
</div>
            <h1 className="text-3xl font-black  tracking-tight md:text-7xl">
              Moving India with cleaner, smarter last-mile mobility.
            </h1>
            <p className="mt-6 max-w-1xl text-lg leading-8 text-slate-100 md:text-xl">
Cleaner rides. Faster deliveries. Smarter cities.
            </p>
            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
              <button
                onClick={() => window.dispatchEvent(new CustomEvent("openJoinNowModal"))}
                className="inline-flex items-center justify-center gap-2 rounded-full bg-lime-300 px-6 py-3 font-bold text-slate-950 shadow-2xl shadow-lime-500/20 transition hover:-translate-y-0.5 hover:bg-white"
              >
                Get EV
                <ArrowRight className="h-5 w-5" />
              </button>
              <Link
                to="/services"
                className="inline-flex items-center justify-center gap-2 rounded-full border border-lime-400 bg-grey px-6 py-3 font-bold text-slate-100 shadow-2xl shadow-lime-500/30 transition hover:-translate-y-0.5 hover:bg-lime-300 hover:text-slate-900"
              >
                Explore Services
              </Link>
            </div>
          </div>

          <div className="mt-8 grid max-w-5xl grid-cols-2 gap-2 sm:gap-3 md:grid-cols-4">
            {stats.map((item) => (
              <div
                key={item.label}
                className="rounded-xl sm:rounded-2xl border border-white/12 bg-white/10 p-2 sm:p-5 backdrop-blur-md flex flex-col items-center"
              >
                <div className="text-xl sm:text-3xl font-black text-lime-200">{item.value}</div>
                <div className="mt-1 text-xs sm:text-sm text-slate-200">{item.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-[#f6faf7] px-5 py-20 lg:px-8">
        <div className="mx-auto max-w-7xl">
          <div className="mb-10 flex flex-col justify-between gap-6 md:flex-row md:items-end">
            <div>
              <p className="text-sm font-bold uppercase tracking-[0.28em] text-emerald-700">What We Do</p>
              <h2 className="mt-3 max-w-3xl text-4xl font-black tracking-tight text-slate-950 md:text-5xl">
                A complete EV operating layer for delivery and mobility.
              </h2>
            </div>
            <p className="max-w-xl text-slate-600">
              The experience is designed around practical city operations: enough polish for enterprise partners, enough clarity for riders, and enough speed for daily execution.
            </p>
          </div>

          <div className="grid gap-5 lg:grid-cols-3">
            {services.map(({ title, text, image, icon: Icon }) => (
              <article key={title} className="group overflow-hidden rounded-[2rem] border border-slate-200 bg-white shadow-sm transition hover:-translate-y-1 hover:shadow-2xl">
                <div className="relative h-64 overflow-hidden">
                  <img src={image} alt={title} className="h-full w-full object-cover transition duration-700 group-hover:scale-105" />
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-950/70 via-transparent to-transparent" />
                  <div className="absolute bottom-5 left-5 rounded-2xl bg-white/95 p-3 text-emerald-700 shadow-lg">
                    <Icon className="h-7 w-7" />
                  </div>
                </div>
                <div className="p-7">
                  <h3 className="text-2xl font-black text-slate-950">{title}</h3>
                  <p className="mt-3 leading-7 text-slate-600">{text}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-white px-5 py-20 lg:px-8">
        <div className="mx-auto grid max-w-7xl gap-10 lg:grid-cols-[1.05fr_0.95fr] lg:items-center">
          <div>
            <p className="text-sm font-bold uppercase tracking-[0.28em] text-emerald-700">Control Tower</p>
            <h2 className="mt-3 text-4xl font-black tracking-tight text-slate-950 md:text-5xl">
              Built like an operations dashboard, presented like a premium brand.
            </h2>
            <p className="mt-5 text-lg leading-8 text-slate-600">
              From rider onboarding to fleet uptime, EV91 keeps the operational pieces connected so partners can scale without losing visibility.
            </p>
            <div className="mt-8 grid gap-4 sm:grid-cols-2">
              {operatingSystem.map((item) => (
                <div key={item} className="flex gap-3 rounded-2xl border border-slate-200 bg-slate-50 p-4">
                  <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-emerald-600" />
                  <span className="font-semibold text-slate-700">{item}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="relative">
            <div className="absolute -inset-4 rounded-[2rem] bg-emerald-200/40 blur-3xl" />
            <div className="relative overflow-hidden rounded-[2rem] border border-slate-200 bg-white shadow-2xl">
              <img src={secondBanner} alt="EV91 delivery operations" className="h-80 w-full object-cover opacity-90" />
              <div className="absolute inset-0 bg-gradient-to-t from-emerald-900/40 via-transparent to-transparent" />
              <div className="grid grid-cols-3 gap-px bg-white/10 p-4">
                {[
                  { icon: Route, label: "Routes" },
                  { icon: Gauge, label: "Uptime" },
                  { icon: ShieldCheck, label: "Safety" },
                ].map(({ icon: Icon, label }) => (
                  <div key={label} className="rounded-2xl bg-white/10 p-4 text-center text-white backdrop-blur">
                    <Icon className="mx-auto h-6 w-6 text-lime-300" />
                    <div className="mt-2 text-sm font-bold">{label}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="px-5 py-20 text-slate-950 lg:px-8">
        <div className="mx-auto max-w-7xl">
          <div className="mb-10 flex flex-col justify-between gap-6 md:flex-row md:items-end">
            <div>
              <p className="text-sm font-bold uppercase tracking-[0.28em] text-emerald-700">Live Dashboard</p>
              <h2 className="mt-3 max-w-3xl text-4xl font-black tracking-tight md:text-5xl">
                EV91 Impact Dashboard
              </h2>
            </div>
            <p className="max-w-xl text-slate-600">
              Tracking daily orders, CO2 savings, trees impact, EV miles, and battery swaps with the same operating data your old dashboard showed.
            </p>
          </div>

          <div className="grid gap-5 lg:grid-cols-[1.2fr_0.8fr]">
            <div className="rounded-[2rem] border border-emerald-100 p-5 shadow-2xl shadow-slate-200/80">
              <div className="mb-6 flex items-center justify-between gap-4">
                <div>
                  <h3 className="text-2xl font-black">Daily Orders</h3>
                  <p className="text-sm text-slate-500">Sep to Apr order volume in lakhs</p>
                </div>
                <span className="rounded-full bg-emerald-100 px-4 py-2 text-sm font-black text-emerald-800">Live</span>
              </div>
              <div className="h-72 rounded-[1.5rem] border border-emerald-100 p-5">
                <svg viewBox="0 0 720 260" className="h-full w-full" role="img" aria-label="EV91 order growth chart">
                  <defs>
                    <linearGradient id="dashFill" x1="0" x2="0" y1="0" y2="1">
                      <stop offset="0%" stopColor="#10b981" stopOpacity="0.35" />
                      <stop offset="100%" stopColor="#10b981" stopOpacity="0" />
                    </linearGradient>
                  </defs>
                  {[40, 90, 140, 190, 240].map((y) => (
                    <line key={y} x1="20" x2="700" y1={y} y2={y} stroke="rgba(15,107,74,0.12)" />
                  ))}
                  {/* Dynamic graph generation based on dailyOrders */}
                  {(() => {
                    // SVG dimensions and padding
                    const width = 720;
                    const height = 260;
                    const paddingX = 30;
                    const paddingY = 40;
                    const graphHeight = height - paddingY - 30;
                    const graphWidth = width - 2 * paddingX;
                    const points = dailyOrders.map((item, idx) => {
                      const x = paddingX + (graphWidth / (dailyOrders.length - 1)) * idx;
                      // Find min/max for scaling
                      return { ...item, x };
                    });
                    const values = dailyOrders.map((d) => d.value);
                    const minValue = Math.min(...values);
                    const maxValue = Math.max(...values);
                    // Y axis: higher value = lower y (SVG)
                    const getY = (val) => {
                      // Invert so maxValue is at paddingY, minValue at height-30
                      if (maxValue === minValue) return height / 2;
                      return paddingY + ((maxValue - val) / (maxValue - minValue)) * graphHeight;
                    };
                    // const svgPoints = points.map((p, i) => `${p.x},${getY(p.value)}`).join(' ');
                    // Area fill path
                    const areaPath = `M${points[0].x},${height-30} ` +
                      points.map((p) => `L${p.x},${getY(p.value)}`).join(' ') +
                      ` L${points[points.length-1].x},${height-30} Z`;
                    // Line path
                    const linePath = `M${points[0].x},${getY(points[0].value)}` +
                      points.slice(1).map((p) => `L${p.x},${getY(p.value)}`).join('');
                    return (
                      <>
                        <path d={areaPath} fill="url(#dashFill)" />
                        <path d={linePath} fill="none" stroke="#0f6b4a" strokeWidth="6" strokeLinecap="round" />
                        {points.map((p) => (
                          <circle key={p.month} cx={p.x} cy={getY(p.value)} r="8" fill="#0f6b4a" stroke="#ecfdf5" strokeWidth="4" />
                        ))}
                        {points.map((p) => (
                          <text key={p.month} x={p.x} y={height-5} fill="#64748b" fontSize="18" textAnchor="middle">{p.month}</text>
                        ))}
                      </>
                    );
                  })()}
                </svg>
              </div>
              <div className="mt-5 grid gap-3 sm:grid-cols-4">
                {dailyOrders.map(({ month, value }) => (
                  <div key={month} className="rounded-2xl border border-emerald-100 bg-slate-50 p-4">
                    <div className="text-sm text-slate-500">{month}</div>
                    <div className="text-2xl font-black text-emerald-700">{value}L</div>
                  </div>
                ))}
              </div>
            </div>

            <div className="grid gap-5">
              {[
                { label: "CO2 Saved", value: "2,392+ metric tons", icon: Leaf },
                { label: "Trees Impact", value: "1,13,915+ trees", icon: Leaf },
                { label: "EV Miles", value: "2000K km+", icon: Route },
                { label: "Deliveries", value: "1,65,00,000+", icon: PackageCheck },
              ].map(({ label, value, icon: Icon }) => (
                <div key={label} className="rounded-[1.5rem] border border-emerald-100 p-6 shadow-xl shadow-slate-200/70">
                  <div className="flex items-center justify-between">
                    <div>
                      <p className="text-sm font-bold uppercase tracking-[0.18em] text-slate-400">{label}</p>
                    <p className="mt-2 text-3xl font-black text-slate-950">{value}</p>
                  </div>
                    <div className="grid h-14 w-14 place-items-center rounded-2xl bg-emerald-100 text-emerald-800">
                      <Icon className="h-7 w-7" />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="bg-slate-950 px-5 py-20 text-white lg:px-8">
        <div className="mx-auto grid max-w-7xl gap-10 lg:grid-cols-[0.9fr_1.1fr] lg:items-center">
          <div>
            <p className="text-sm font-bold uppercase tracking-[0.28em] text-lime-300">City Network</p>
            <h2 className="mt-3 text-4xl font-black tracking-tight md:text-5xl">Scaling city by city with local execution.</h2>
            <p className="mt-5 text-lg leading-8 text-slate-300">
              EV91 is present across major Indian delivery markets with hubs, riders, EVs, and partner operations.
            </p>
            <div className="mt-8 overflow-hidden rounded-[2rem] border border-white/10 bg-white/5 p-5">
              <img src={mapImage} alt="EV91 India presence map" className="mx-auto max-h-80 object-contain" />
            </div>
          </div>

          <div className="grid gap-4 sm:grid-cols-2">
            {cities.map((city) => (
              <article key={city.name} className="overflow-hidden rounded-3xl border border-white/10 bg-white/8">
                <img src={city.image} alt={city.name} className="h-44 w-full object-cover" />
                <div className="p-5">
                  <div className="flex items-center gap-2 text-lime-200">
                    <MapPin className="h-4 w-4" />
                    <h3 className="font-black">{city.name}</h3>
                  </div>
                  <p className="mt-2 text-sm text-slate-300">{city.detail}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-white px-5 py-20 lg:px-8">
        <div className="mx-auto grid max-w-7xl gap-10 lg:grid-cols-[1fr_1fr] lg:items-center">
          <div className="relative overflow-hidden rounded-[2rem] border border-emerald-200 bg-white-to-br from-slate-900 via-slate-800 to-emerald-950 p-4 ]">

  {/* Image */}
  <img
    src={safetyTech}
    alt="EV91 fleet safety technology"
    className="h-[420 px] w-100 rounded-[1.5rem]"
  />

  {/* Soft Overlay */}
  <div className="absolute inset-4 rounded-[1.5rem] bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>

  {/* Glow Effect */}
  <div className="absolute -bottom-20 left-1/2 h-52 w-52 -translate-x-1/2 rounded-full bg-emerald-500/20 blur-3xl"></div>

  {/* Text */}
  <div className="absolute bottom-10 left-10 right-10 text-white">
    <p className="text-sm font-black uppercase tracking-[0.24em] text-lime-300">
      Fleet Safety
    </p>

    <h2 className="mt- text-4xl font-black leading-tight tracking-tight drop-shadow-xl">
      EV91's Fleet Safety Tech & SOPs
    </h2>
  </div>
</div>
          <div>
            <p className="text-sm font-bold uppercase tracking-[0.28em] text-emerald-700">Operations Discipline</p>
            <h2 className="mt-3 text-4xl font-black tracking-tight text-slate-950 md:text-5xl">
              Safety is engineered into every electric mile.
            </h2>
            <p className="mt-5 text-lg leading-8 text-slate-600">
              EV91 supports riders and partners with structured SOPs, safety checks, charging discipline, route awareness, and operating controls designed for real-world city logistics.
            </p>
            <div className="mt-8 grid gap-4 sm:grid-cols-2">
              {[
                "Daily vehicle readiness checks",
                "Rider onboarding and SOP training",
                "Route and hub-level escalation flows",
                "Maintenance visibility and uptime support",
              ].map((item) => (
                <div key={item} className="flex gap-3 rounded-2xl border border-emerald-100 bg-emerald-50/70 p-4">
                  <ShieldCheck className="mt-0.5 h-5 w-5 shrink-0 text-emerald-700" />
                  <span className="font-bold text-slate-800">{item}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="bg-[#f6faf7] px-5 py-20 lg:px-8">
        <div className="mx-auto max-w-7xl">
          <div className="grid gap-8 lg:grid-cols-[0.95fr_1.05fr] lg:items-center">
            <div className="rounded-[2rem] bg-white p-5 shadow-xl shadow-slate-200/70">
              <img src={missionImage} alt="EV91 mission" className="rounded-[1.5rem] object-cover" />
            </div>
            <div>
              <p className="text-sm font-bold uppercase tracking-[0.28em] text-emerald-700">Impact</p>
              <h2 className="mt-3 text-4xl font-black tracking-tight text-slate-950 md:text-5xl">
                Cleaner miles, stronger riders, better logistics.
              </h2>
              <p className="mt-5 text-lg leading-8 text-slate-600">
                EV91 is focused on practical sustainability: deploying EVs where delivery density is highest, supporting riders with access and training, and giving businesses cleaner last-mile capacity.
              </p>
              <div className="mt-8 grid gap-4 sm:grid-cols-3">
                {[
                  { icon: Leaf, label: "Lower emissions" },
                  { icon: Factory, label: "Enterprise ready" },
                  { icon: Zap, label: "Fast deployment" },
                ].map(({ icon: Icon, label }) => (
                  <div key={label} className="rounded-2xl border border-emerald-100 bg-white p-5 shadow-sm">
                    <Icon className="h-7 w-7 text-emerald-600" />
                    <div className="mt-3 font-black text-slate-900">{label}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="mt-16 overflow-hidden rounded-[2rem] border border-slate-200 bg-white py-8 shadow-sm">
            <p className="px-8 text-center text-sm font-bold uppercase tracking-[0.24em] text-slate-500">
              Trusted by delivery and commerce partners
            </p>
            <div className="mt-8 flex animate-[logoRail_24s_linear_infinite] items-center gap-12 whitespace-nowrap px-8">
              {[...logos, ...logos].map((logo, index) => (
                <img key={index} src={logo} alt={`EV91 client ${index + 1}`} className="h-14 w-32 shrink-0 object-contain  hover:grayscale-0" />
              ))}
            </div>
          </div>

          <div className="mt-10 grid gap-6 lg:grid-cols-[0.75fr_1.25fr]">
            <div className="rounded-[2rem] bg-slate-950 p-8 text-white shadow-2xl">
              <p className="text-sm font-black uppercase tracking-[0.24em] text-lime-300">Investors</p>
              <h3 className="mt-3 text-3xl font-black">Built for scale, backed by trust.</h3>
              <p className="mt-4 leading-7 text-slate-300">
                EV91 is building a cleaner logistics network for India with partnerships across OEMs, finance, service, and enterprise delivery.
              </p>
              <div className="mt-6 grid grid-cols-3 gap-3">
                {["EV Fleet", "3PL", "Rental"].map((item) => (
<div
  key={item}
  className="
    group
    rounded-2xl
    border border-white/20
    bg-white/10
    p-4
    text-center
    backdrop-blur-xl
    shadow-xl
    transition-all
    duration-300
    hover:-translate-y-1
    hover:bg-white/15
    hover:border-lime-300/40
  "
>
  <span className="text-base font-black tracking-wide text-white">
    {item}
  </span>
</div>             
 ))}
              </div>
            </div>
            <div className="rounded-[2rem] border border-slate-200 bg-white p-8 shadow-sm">
              <p className="text-sm font-black uppercase tracking-[0.24em] text-slate-500">Commercial Partners</p>
              <div className="mt-6 grid grid-cols-2 gap-4 sm:grid-cols-4">
                {commercialPartners.map((logo, index) => (
                  <div key={index} className="grid h-28 place-items-center rounded-2xl border border-emerald-100 bg-slate-50 p-4 transition hover:-translate-y-1 hover:bg-white hover:shadow-xl">
                    <img src={logo} alt={`Commercial partner ${index + 1}`} className="max-h-16 object-contain" />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="relative overflow-hidden bg-emerald-700 px-5 py-12 text-white lg:px-8">
        {/* <img src={mobileApp} alt="EV91 mobile app interface" className="absolute bottom-0 right-6 hidden max-h-[420px] opacity-25 lg:block" /> */}
        <div className="relative mx-auto max-w-5xl text-center">
          <h2 className="text-4xl font-black tracking-tight md:text-6xl">Ready to put EVs into motion?</h2>
          <p className="mx-auto mt-5 max-w-2xl text-lg leading-8 text-emerald-50">
            Partner with EV91 for delivery operations, rider enablement, EV rentals, and sustainable fleet growth.
          </p>
          <button
            onClick={() => window.dispatchEvent(new CustomEvent("openJoinNowModal"))}
            className="mt-8 inline-flex items-center justify-center gap-2 rounded-full bg-white px-7 py-3 font-black text-emerald-800 shadow-2xl transition hover:-translate-y-0.5"
          >
            Start With EV91
            <ArrowRight className="h-5 w-5" />
          </button>
        </div>
      </section>

      <style>{`
        @keyframes logoRail {
          from { transform: translateX(0); }
          to { transform: translateX(-50%); }
        }
      `}</style>
      <ScrollToTopButton />
    </>
  );
};

export default Home;
